var novicell = novicell || {};

// Init on document ready
//$(function () {
//    novicell.cookieInfo.init();
//});

//novicell.cookieInfo = new function(){
//    //var self = this;
//    //var $body = $('body');

//    this.init = function () {

//        var $allowallSelection = $('#CybotCookiebotDialogBodyLevelButtonLevelOptinAllowallSelection');
//        var $allowAll = $('#CybotCookiebotDialogBodyLevelButtonLevelOptinAllowAll');

//        if (getCookie("cookieAccept") !== "accepted") {
//            setCookie("cookieAccept", "notaccepted", 365);
//        }

//        if (getCookie("cookieAccept") === "notaccepted") {
//            $(".cookieaccept").remove();
//        }
//        else  {
//            $(".nocookieaccept").remove();
//        }

//        $allowAll.click(function () {
//            acceptCookie();
//        });

//        $allowallSelection.click(function () {

//            if ($('#CybotCookiebotDialogBodyLevelButtonMarketing').prop('checked') && $('#CybotCookiebotDialogBodyLevelButtonStatistics').prop('checked')) {

//                acceptCookie();
//            }
//            else {
//                setCookie("cookieAccept", "notaccepted", 365);
//            }
           
//        });
//    };
//};

/* Cookie helper functions
*******************************/
    
// Get cookie
function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i=0; i<ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0)===' '){ c = c.substring(1) };
        if (c.indexOf(name) === 0){ return c.substring(name.length,c.length)};
    }
    return "";
}

// Set cookie
function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 60 * 60 * 1000 * 24));
    var expires = "expires=" + d.toUTCString() + ";";
    var path = "path=/";
    document.cookie = cname + "=" + cvalue + "; " + expires + path;
}

function acceptCookie() {
    setCookie("cookieAccept", "notaccepted", -1);
    setTimeout(function () {
        setCookie("cookieAccept", "accepted", 365);
        location.reload();
    }, 1000);
}